/* Better Days Customs: colour swatches on product cards, from the S&S swatch dataset.
   Clicking a swatch swaps the card photo to that colour. */
(function () {
  'use strict';
  var LIMIT = 12;
  var SWURL = 'https://cdn.ssactivewear.com/Images/ColorSwatch/';
  var IMGURL = 'https://cdn.ssactivewear.com/Images/Color/';

  function rowFor(raw, handle) {
    var all = (raw || '').split('~');
    for (var i = 0; i < all.length; i++) {
      var p = all[i].indexOf('^');
      if (p > 0 && all[i].slice(0, p) === handle) return all[i].slice(p + 1);
    }
    return null;
  }

  function parse(row) {
    var q = row.split('|');
    var list = [];
    for (var k = 0; k < q.length; k++) {
      var b = q[k].lastIndexOf(':');
      var a = q[k].lastIndexOf(':', b - 1);
      if (a < 0 || b < 0) continue;
      list.push({ name: q[k].slice(0, a), sw: q[k].slice(a + 1, b), img: q[k].slice(b + 1) });
    }
    return list;
  }

  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }

  function chip(c) {
    return '<button type="button" class="bdc-c__sw" data-bdc-sw="' + esc(c.img) + '" title="' + esc(c.name) +
      '" aria-label="Show ' + esc(c.name) + '">' +
      '<img src="' + SWURL + c.sw + '_fm.jpg" alt="" loading="lazy" width="18" height="18">' +
      '</button>';
  }

  function cardOf(el) {
    return el.closest('.bdc-c') || el.closest('.bdc-card') || el.closest('li') || el.closest('article') || el.parentElement;
  }

  function mainImg(holder) {
    var card = cardOf(holder);
    if (!card) return null;
    var imgs = card.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      if (!imgs[i].closest('[data-bdc-cardsw]')) return imgs[i];
    }
    return null;
  }

  function select(holder, btn) {
    var img = mainImg(holder);
    if (!img) return;
    if (!img.getAttribute('data-bdc-orig')) {
      img.setAttribute('data-bdc-orig', img.currentSrc || img.src || '');
      img.setAttribute('data-bdc-origset', img.getAttribute('srcset') || '');
      img.setAttribute('data-bdc-origsizes', img.getAttribute('sizes') || '');
    }
    var id = btn.getAttribute('data-bdc-sw');
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = IMGURL + id + '_f_fm.jpg';
    var sibs = holder.querySelectorAll('.bdc-c__sw');
    for (var i = 0; i < sibs.length; i++) {
      var on = sibs[i] === btn;
      sibs[i].classList.toggle('is-active', on);
      sibs[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  }

  function wire(holder) {
    holder.addEventListener('click', function (e) {
      var more = e.target.closest ? e.target.closest('.bdc-c__more') : null;
      if (more && holder.contains(more)) {
        e.preventDefault();
        e.stopPropagation();
        var rest = holder.getAttribute('data-bdc-rest');
        if (rest) {
          more.insertAdjacentHTML('beforebegin', rest);
          holder.removeAttribute('data-bdc-rest');
        }
        more.parentNode.removeChild(more);
        return;
      }
      var btn = e.target.closest ? e.target.closest('.bdc-c__sw') : null;
      if (!btn || !holder.contains(btn)) return;
      e.preventDefault();
      e.stopPropagation();
      select(holder, btn);
    });
  }

  function paint() {
    var raw = window.BDC_SW_RAW;
    if (!raw) return;
    var els = document.querySelectorAll('[data-bdc-cardsw]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.getAttribute('data-bdc-done')) continue;
      var row = rowFor(raw, el.getAttribute('data-bdc-cardsw'));
      if (!row) { el.setAttribute('data-bdc-done', '1'); continue; }
      var list = parse(row);
      var html = '';
      var shown = Math.min(LIMIT, list.length);
      for (var k = 0; k < shown; k++) html += chip(list[k]);
      if (list.length > shown) {
        var rest = '';
        for (var r = shown; r < list.length; r++) rest += chip(list[r]);
        el.setAttribute('data-bdc-rest', rest);
        html += '<button type="button" class="bdc-c__more" aria-label="Show the other ' +
          (list.length - shown) + ' colors">+' + (list.length - shown) + '</button>';
      }
      el.innerHTML = html;
      el.setAttribute('data-bdc-done', '1');
      wire(el);
    }
  }

  function boot() {
    if (window.BDC_SW_RAW) { paint(); return; }
    if (!window.BDC_SW_URL) return;
    fetch(window.BDC_SW_URL).then(function (r) { return r.text(); }).then(function (t) {
      window.BDC_SW_RAW = t;
      paint();
    }).catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.addEventListener('load', paint);
  document.addEventListener('shopify:section:load', boot);
})();
